
<template>
  <StatusBadge :data="statusData" @action="onAction" />
</template>

<script>
import StatusBadge from '@components/StatusBadge.vue'

export default {
  name: 'UserStatus',
  components: { StatusBadge },
  emits: ['invitationAction'],
  props: {
    status: String,
    user: Object
  },
  computed: {
    statusData () {
      const statuses = {
        approved: { class: 'approved', label: 'Active' },
        pending: {
          class: 'invited',
          label: 'Invitation pending',
          tooltip: { title: `${this.user.email}<br/> has been invited` },
          action: () => this.$emit(
            'invitationAction',
            this.user.actual_invitation.id,
            this.user.id,
            true
          )
        },
        expired: {
          class: 'expired',
          label: 'Invitation expired',
          action: () => this.$emit(
            'invitationAction',
            this.user.actual_invitation.id,
            this.user.id,
            true
          )
        },
        inactive: { class: 'inactive', label: 'Inactive' }
      }

      if (this.status === 'invited') { return this.user.is_invitation_expired ? statuses.expired : statuses.pending }

      return statuses[this.status] || statuses.approved
    }
  },
  methods: {
    onAction () {
      this.$emit(
        'invitationAction',
        this.user.actual_invitation.id,
        this.user.id,
        !this.user.is_invitation_expired
      )
    }
  }
}
</script>

<!-- <template>
  <div class="item" :class="statusData.class" @click="() => statusData.action()"
      v-b-tooltip="{ variant: 'secondary', customClass: 'tooltip-item'}"
      v-b-tooltip.html="statusData.tooltip"
    >
    {{statusData.label}}
  </div>
</template>

<script>
export default {
  name: 'UserStatus',
  emits: ['invitationAction'],
  props: {
    status: {
      type: String
    },
    invitation: {
      type: [Object, null]
    },
    user: {
      type: Object
    }
  },
  data () {
    return {
      statuses: {
        approved: { class: 'approved', label: 'Active' },
        pending: { class: 'invited', label: `Invitation pending`, tooltip: { title: `${this.user.email}<br/> has been invited`, html: true }, action: () => this.$emit('invitationAction', this.user.actual_invitation.id, this.user.id, true) },
        expired: { class: 'expired', label: 'Invitation expired', action: () => this.$emit('invitationAction', this.user.actual_invitation.id, this.user.id, false) },
        inactive: { class: 'inactive', label: 'Inactive' }
      }
    }
  },
  computed: {
    statusData () {
      switch (this.status) {
        case 'invited':
          if (this.user.is_invitation_expired) {
            return this.statuses.expired
          } else {
            return this.statuses.pending
          }

        case 'inactive':
          return this.statuses.inactive

        case 'active':
          return this.statuses.approved

        default:
          return this.statuses.approved
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.item {
  padding: 8px 16px;
  height: 24px;
  border-radius: 25px;
  text-align: center;
  font-size: 12px;
  font-family: 'Ubuntu';
  font-weight: 400;
  width: fit-content;
  display: flex;
  align-items: center;
}

.approved {
  background-color: #C3E6CB;
  color: #3D5170;
}

.invited {
  background-color: #DEEBFF;
  color: #3D5170;
  cursor: pointer;
}

.expired {
  background-color: #F8D7DA;
  color: #3D5170;
  cursor: pointer;
}

.inactive {
  background-color: #E4E7EE;
  color: #3D5170;
  cursor: pointer;
}

.tooltip-item::v-deep .tooltip-inner {
  white-space: nowrap;
  max-width: max-content;
}

</style> -->
